module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "toctitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/06_fm"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    staticStyle: {
      "margin-bottom": "0.5em",
      "margin-top": "0em",
      "margin-left": "-0.5em",
      "width": "60%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/07_c1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/07_c1"
    }
  }, [_vm._v("The Lone Wolf Strikes")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/08_c2"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/08_c2"
    }
  }, [_vm._v("Long Journey to the Front")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/09_c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/09_c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bad Aircraft and Bad Luck")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/10_c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/10_c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Albion to Zeppelins")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/11_c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/11_c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Triumphs")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/12_c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/12_c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bloody April")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/13_c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/13_c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transformations")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/14_c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/14_c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attack in the Darkness")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/15_c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/15_c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growing Success")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/16_c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/16_c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Hero at Last")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/17_c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/17_c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winged Victory")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/18_c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/18_c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Price Success?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/19_app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/19_app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aerial Victory List of William A. Bishop")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography & Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/21_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/22_maps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    staticStyle: {
      "margin-bottom": "0.5em",
      "margin-top": "0em",
      "margin-left": "-0.5em",
      "width": "60%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "15%"
    }
  }), _c('td', [_c('span', {
    attrs: {
      "href": "#/22_maps#map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60 Squadron Sector in 1917")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('span', {
    attrs: {
      "href": "#/22_maps#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60 Squadron Sector in 1918")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/23_ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b521880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_toc.vue
// module id = 69
// module chunks = 0